class ModelsFetch {
	// store request payloads.
	payloads = new Object();
	// stores processed requests.
	requests = new Object();
	// stores errors
	errors = new Object();

	// constructor
	constructor(endpoint) {
		this.endpoint = endpoint; //http://htmx.local/wp-json/apimodels/v0
	}
	// set payloads
	setPayload(id, body, headers = {}, endpoint = false, method = 'POST') {
		this.payloads[id] = {
			headers: headers,
			body: body,
			method: method,
			initArgs: body.hasOwnProperty('args') ? { ...body.args } : {},
			endpoint: endpoint || this.endpoint
		}
		this.payloads[id].body.args = this.deepFilterPayloadArgs(this.payloads[id].body.args);
		this.errors[id] = new Array();
	}

	async updatePayloadArgs(id, args) {
		!this.payloads[id] && this.error(`No payload set for id: ${payloadId}`)
		let update = { ...this.payloads[id].body.args, ...args };
		this.payloads[id].body.args = await this.deepFilterPayloadArgs(update);
	}

	setRequest(payloadId, data) {
		!this.requests.hasOwnProperty(payloadId) && (this.requests[payloadId] = new Array());
		let saved = this.requests[payloadId].filter(r => r.hash === data.hash).length
		!saved && this.requests[payloadId].push(data);
	}
	//set filters
	async fetchIt(payloadId) {
		try {
			var payload = this.payloads[payloadId];
			!payload && this.error(`No payload set for id: ${payloadId}`)
			const response = await fetch(payload.endpoint, {
				method: payload.method,
				headers: { 'Content-Type': 'application/json', ...payload.headers },
				body: JSON.stringify(payload.body),
			})
			!response.ok && this.errors[payloadId].push(response) && this.error(`Invalid requisition for ${payloadId} with response`, response);
			const data = await response.json();
			data.code !== 'success' && this.errors[payloadId].push(data) && this.error(`Invalid response for ${payloadId} with response`, data);
			this.setRequest(payloadId, data);
			return data;
		} catch (e) {
			console.error(e);
			return false;
		}
	}

	deepFilterPayloadArgs(obj) {
		if (Array.isArray(obj)) {
			return obj
				.map(item => this.deepFilterPayloadArgs(item))
				.filter(item => item !== null && item !== undefined);
		} else if (obj !== null && typeof obj === 'object') {
			const filteredObject = {};
			Object.keys(obj).forEach(key => {
				const value = this.deepFilterPayloadArgs(obj[key]);
				if (value !== null && value !== undefined) {
					filteredObject[key] = value;
				}
			});

			// Check if filteredObject is empty after filtering
			if (Object.keys(filteredObject).length === 0) {
				return null; // Return null for empty objects
			} else {
				return filteredObject;
			}
		} else {
			return obj;
		}
	}

	error($message, $object = false) {
		$object && console.error($object)
		throw new Error($message);
	}
}

class TemplateProcessor {
	constructor() {
		this.parser = new DOMParser();
		this.funcs = {};
	}

	setFunc(name, callable) {
		if (this.funcs.hasOwnProperty(name)) {
			console.error(`Function ${name} already registred`)
			return;
		}
		this.funcs[name] = callable;
	}

	getDataValue(param, data) {
		return param.split('.').reduce((acc, key) => acc ? acc[key.trim()] : undefined, data);
	}

	escapeRegex(string) {
		return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}

	process(template, data) {
		template = template;
		const regex = /{{(.*?)}}/g;
		const matches = template.match(regex);
		if (!matches) return template;

		const terms = [...new Set(matches.map(match => match.slice(2, -2)))];

		terms.forEach(term => {
			const [func, ...params] = term.split(':');
			const paramStr = params.join(':');
			const paramList = paramStr.split(',').map(param => param.trim());
			const isFunction = this.funcs.hasOwnProperty(func);
			const value = isFunction
				? this.processFunction(func, paramList, data)
				: this.getDataValue(func, data);

			const escapedTerm = this.escapeRegex(term);
			const termRegex = new RegExp(`{{${escapedTerm}}}`, 'g');
			template = template.replaceAll(termRegex, value);
		});

		return template;
	}

	processFunction(func, paramList, data) {
		if (!this.funcs[func]) {
			console.error(`Callable function not registered: ${func}`);
			return '';
		}

		if (paramList.length === 1 && paramList[0] === '*') {
			return this.funcs[func](data);
		}

		const values = paramList.map(param => this.getDataValue(param, data));
		return this.funcs[func](...values);
	}
}

class ModelsFilter {
	filters = {
		change: new Array(),
		submit: new Array(),
		input: new Array(),
	}

	constructor(formSelector) {
		this.formSelector = formSelector;
	}

	async formProcessor(form) {
		let formData = new FormData(form);
		let data = {};

		for (let [key, value] of formData.entries()) {
			if (key.endsWith('[]')) {
				key = key.slice(0, -2);
				if (!data[key]) {
					data[key] = [];
				}
				data[key].push(value);
			} else {
				data[key] = value;
			}
		}
		return data;
	}

	async process(e, args) {
		let form = e.target === window ? document.querySelector(this.formSelector) : window && e.target.closest(this.formSelector);

		if (!form) return false;

		e.preventDefault();
		e.stopImmediatePropagation();

		this.data = await this.formProcessor(form);
		Object.keys(this.filters[e.type]).forEach(key => {
			args = this.filters[e.type][key](args, this.data, e)
		})

		return {
			update: this.filters[e.type].length > 0,
			args: args,
		}
	}

	setFilter(event, callable) {
		this.filters[event].push(callable);
	}

	resetFilter() {
		let forms = document.querySelectorAll(this.formSelector);
		if (!forms) return;
		forms.forEach(async form => {
			let data = await this.formProcessor(form);
			Object.keys(data).forEach(sel => {
				let fields = form.querySelectorAll(`[name="${sel}"],[name="${sel}[]"]`);
				fields && fields.forEach(field => {
					field.getAttribute('type') === 'checkbox' ? field.checked = false : field.value = '';
				})
				this.data && this.data.hasOwnProperty(sel) && delete this.data[sel];
			})
		})
	}

}

export class ModelsTemplates {

	filters = {};
	templates = [];
	events = (attr) => {
		return {
			beforeFetch: `${this.attr}:beforeFetch`,
			fetch: `${this.attr}:fetch`,
			afterFetch: `${this.attr}:afterFetch`,
			beforeRender: `${this.attr}:beforeRender`,
			afterRender: `${this.attr}:afterRender`,
			noResults: `${this.attr}:noResults`,
			beforeFilter: `${this.attr}:beforeFilter`,
			afterFilter: `${this.attr}:afterFilter`,
			error: `${this.attr}:error`,
			reset: `${this.attr}:reset`
		}
	};

	constructor(setup) {
		this.attr = 'atempl';
		this.events = this.events();
		this.doSetup(setup);
		this.rasterTemplates();

	}

	doSetup(setup) {
		if (!setup?.endpoint) this.error('Exit: No endpoint set');
		this.models = new ModelsFetch(setup.endpoint);
		this.templateProcessor = new TemplateProcessor();
		this.filterListeners();
		this.attr = setup.attr || this.attr;
	}

	async init() {
		await this.onLoad();
		window.addEventListener('click', this.onClick.bind(this), false);
		const throttle = this.throttle(this.onReveal.bind(this), 500);
		window.addEventListener('scroll', throttle, true)
	}

	async registerTemplate(templ) {

		const parseHTML = (templ) => {
			const parser = new DOMParser();
			const doc = parser.parseFromString(htmlString, 'text/html');
			return doc.querySelector(`[${this.attr}]`)?.cloneNode(true) || false;
		}

		const getWrapperElement = (templ) => {
			let wrapper = templ.getAttribute(`${this.attr}-wrapper`);
			wrapper = (wrapper && document.body.querySelector(wrapper)) || templ.parentElement;
			return (wrapper && wrapper.closest('body')) ? wrapper : false;
		}

		const updateWrapperUniqueId = (wrapper, uniq, templId) => {
			const existingUniq = wrapper.getAttribute(`${this.attr}-uniq`);
			const existingID = wrapper.getAttribute(`${this.attr}-id`);
			wrapper.setAttribute(`${this.attr}-uniq`, existingUniq ? `${existingUniq}-${uniq}` : uniq);
			wrapper.setAttribute(`${this.attr}-id`, existingID ? `${existingID}-${templId}` : templId)
		}

		templ = templ instanceof Node ? templ : parseHTML(templ);
		if (!templ) return;

		const uniq = this.generateUniqueId();
		let wrapper = getWrapperElement(templ);
		wrapper && updateWrapperUniqueId(wrapper, uniq, templ.getAttribute(this.attr));

		this.templates.push({
			uniq,
			wrapper: () => document.querySelector(`[${this.attr}-uniq*="${uniq}"]`),
			template: templ.cloneNode(true),
			id: templ.getAttribute(this.attr),
			on: templ.getAttribute(`${this.attr}-on`) || 'load',
			indicators: templ.getAttribute(`${this.attr}-indicators`),
			status: ['idle'],
			mode: templ.getAttribute(`${this.attr}-mode`) || 'append',
		});

		templ.remove();
	}

	async rasterTemplates() {
		const templates = document.querySelectorAll(`[${this.attr}]`);
		if (!templates.length) return;
		for (const templ of templates) {
			await this.registerTemplate(templ);
		}
	}

	async reprocess() {
		await this.rasterTemplates();
		await this.onLoad();
	}

	async onLoad() {
		const templatesToLoad = this.templates.filter(templ =>
			templ.status.includes('idle') &&
			document.querySelector(`[${this.attr}-uniq*="${templ.uniq}"]`) &&
			templ.on === 'load'
		);

		for (const templ of templatesToLoad) {
			await this.parseFilterQueryString(templ.id);
			await this.request(templ, document.querySelector(`[${this.attr}-uniq*="${templ.uniq}"]`), templ.mode);
		}
	}

	buttonAction(target, actionType) {
		const statusSet = ['loading', 'no-results', 'error', 'complete'];
		const targetStatus = target.getAttribute(`${this.attr}-status`);
		const containsComplete = targetStatus && statusSet.some(status => targetStatus.includes(status));

		const actions = this.parseTrigger(target.getAttribute(`${this.attr}-trigger`) || target.getAttribute(`data-${this.attr}-trigger`));
		const action = actions[actionType];
		if (!action) return;

		for (const [act, update] of Object.entries(action)) {
			const template = this.templates.find(templ => templ.id === act);
			if (template && update.hasOwnProperty('reset')) {
				this.reset(template.id, update.reset && update.reset !== true ? update.reset : 'replace');
				return;
			}
			if (containsComplete) return;
			const render = template && !statusSet.some(status => targetStatus.includes(status));
			if (template && (actionType === 'click' || render)) {
				this.updater(template.id, update, template.mode);
			}
		}
	}

	onClick(e) {
		const target = e.target.closest(`[${this.attr}-trigger*="click"],[data-${this.attr}-trigger*="click"]`);
		if (!target) return;
		this.buttonAction(target, 'click');
	}

	onReveal(e) {
		const targets = document.querySelectorAll(`[${this.attr}-trigger*="reveal"],[data-${this.attr}-trigger*="reveal"]`);
		if (!targets) return;

		targets.forEach(target => {
			if (this.isScrolledIntoView(target)) {
				this.buttonAction(target, 'reveal');
			}
		});
	}


	async request(templ, wrapper, mode = 'append') {

		if (!wrapper || !this.models.payloads[templ.id]) return;

		let cancelled = false;
		let response = null;

		// Filter before fetch.
		({ templ, wrapper, mode, cancelled } = await this.fireEvent('beforeFetch', {
			'templ': templ,
			'wrapper': wrapper,
			'mode': mode,
			'payload': this.models.payloads[templ.id],
		}));

		// Init
		this.setStatus('init', templ);

		// Filtering states.
		let hasFilter = await this.hasFilter(templ, true, { 'wrapper': wrapper, 'mode': mode })
		let isFilteringFirst = !this.isFilterSet(templ) && hasFilter;
		let isResetting = this.isFilterSet(templ) && !hasFilter;
		this.setStatus('filtering', templ, !hasFilter)
		this.setStatus('triggering-filter', templ, !isFilteringFirst)
		this.setStatus('resetting', templ, !isResetting)

		// If before fecth was cancelled in event.
		if (cancelled) return false;

		// Set loading
		this.setStatus('loading', templ);

		// Check if first page.
		let paged = this.models.payloads[templ.id].body?.args?.paged;
		this.setStatus('first-page', templ, paged && paged !== 1);


		({ templ, wrapper, mode, response, cancelled } = await this.fireEvent('fetch', {
			'templ': templ,
			'wrapper': wrapper,
			'mode': mode,
			'payload': this.models.payloads[templ.id],
			'response': null,
		}));

		// If cancelled on fetch
		if (cancelled) return false;

		if( response !== null ){
			this.models.requests[templ.id] ? this.models.requests[templ.id].push(response) : (this.models.requests[templ.id] = [response]) ;
		}else{
			response = await this.models.fetchIt(templ.id)
		}

		// Error handler.
		if (!response) {
			({ templ, wrapper, mode, response } = await this.fireEvent('error', {
				'templ': templ,
				'wrapper': wrapper,
				'mode': mode,
				'payload': this.models.payloads[templ.id],
				'response': this.models.errors[templ.id][this.models.errors[templ.id].length - 1],
			}, false));
			this.setStatus('error', templ)
			return false;
		}

		// After successfull response.
		({ templ, wrapper, mode, response, cancelled } = await this.fireEvent('afterFetch', {
			'templ': templ,
			'wrapper': wrapper,
			'mode': mode,
			'payload': this.models.payloads[templ.id],
			'response': response,
		}));

		// Has filter state.
		this.setStatus('has-filter', templ, !hasFilter)


		// Create html.
		let html = response.posts.map(post => this.templateProcessor.process(templ.template.innerHTML, post)).join('');
		let holder = document.createElement('div');
		holder.setAttribute('data-page', response.pagination.curr_page);
		holder.innerHTML = html;


		// Filter html.
		({ templ, wrapper, mode, response, holder } = await this.fireEvent('beforeRender', {
			'templ': templ,
			'wrapper': wrapper,
			'mode': mode,
			'payload': this.models.payloads[templ.id],
			'response': response,
			'holder': holder,
		}));

		// If beforeRender was cancelled in event.
		if (cancelled) return false;

		// Render HTML.
		if (mode === 'replace') wrapper.innerHTML = '';
		if (['append', 'replace'].includes(mode)) wrapper.append(holder);
		if (mode === 'prepend') wrapper.prepend(holder);

		// After render filter.
		({ templ, wrapper, mode, response, holder } = await this.fireEvent('afterRender', {
			'templ': templ,
			'wrapper': wrapper,
			'mode': mode,
			'payload': this.models.payloads[templ.id],
			'response': response,
			'holder': holder,
		}, false));

		// Loaded status.
		this.setStatus('loaded', templ)

		// Complete status.
		!response.pagination.next_page && this.setStatus('complete', templ);

		// Case no results, fire no results event.
		if (!response.pagination.total_count) {
			this.setStatus('no-results', templ);
			({ templ, wrapper, mode, response, holder } = await this.fireEvent('noResults', {
				'templ': templ,
				'wrapper': wrapper,
				'mode': mode,
				'payload': this.models.payloads[templ.id],
				'response': response,
				'holder': holder,
			}, false));
		}
	}

	async hasFilter(templ, fireEvent = true, additionalEventArgs = {}) {

		const payload = templ?.id && this.models.payloads[templ.id];

		if (!payload) {
			return false;
		}

		let args = { ...payload.body.args }
		let initArgs = { ...payload.initArgs }

		if (fireEvent) {
			const event = new CustomEvent(`${this.attr}:hasFilter`, {
				detail: {
					templ,
					payload,
					result: null,
					...additionalEventArgs
				}
			});

			window.dispatchEvent(event);

			if (event.detail.result !== null && event.detail.result !== undefined) {
				return event.detail.result;
			}
		}

		args.paged && delete args.paged
		initArgs.paged && delete initArgs.paged;

		return JSON.stringify(args) !== JSON.stringify(initArgs);
	}

	isFilterSet(templ) {
		return templ.status.includes('has-filter');
	}

	async updater(id, update, mode = 'append') {

		const resolveIncrementDecrement = (payload, key, value) => {
			if (value === '++') {
				return payload.body.args[key] ? payload.body.args[key] + 1 : 2;
			} else if (value === '--') {
				return payload.body.args[key] ? payload.body.args[key] - 1 : delete payload.body.args[key];
			} else {
				return value;
			}
		}

		const payload = this.models.payloads[id];
		if (!payload || !update) return;

		for (const [key, value] of Object.entries(update)) {
			if (typeof value === 'function') {
				const resolvedValue = value();
				update[key] = resolvedValue?.value || delete update[key];
			} else {
				update[key] = resolveIncrementDecrement(payload, key, value);
			}
		}
		await this.models.updatePayloadArgs(id, update);
		const template = this.templates.find(templ => templ.id === id);
		if (template) {
			await this.URLSetter(id);
			await this.request(template, template.wrapper(), mode);
			return true;
		}
		return false;
	}

	reset(id, mode = 'replace') {
		const payload = this.models.payloads[id];
		const template = this.templates.find(templ => templ.id === id);

		if (!payload || !template || !this.isFilterSet(template)) return;

		this.models.payloads[id].body.args = { ...payload.initArgs };
		this.filters.hasOwnProperty(id) && this.filters[id].handler.resetFilter();
		this.request(template, template.wrapper(), mode);
		this.URLSetter(id);

		this.fireEvent('reset', {
			'templ': template,
			'wrapper': template.wrapper(),
			'mode': mode,
			'payload': this.models.payloads[id],
		}, false);
	}

	setStatus(status, templ, remove = false) {

		const removeStatus = (status, except = []) => {
			templ.status = templ.status.filter(st => !(status.includes(st) && !except.includes(st)));
		}
		const displayStates = ['complete', 'loaded', 'no-results', 'loading', 'error', 'resetting', 'filtering', 'triggering-filter', 'cancelled'];
		const helperLoadingStates = ['resetting', 'filtering', 'triggering-filter'];
		if (remove) {
			removeStatus(status);
		} else {
			switch (status) {
				case 'idle': // awaiting to be initialized
					templ.status = ['idle'];
					break;
				case 'init': // it is initialized
					removeStatus(['idle']);
					!remove && templ.status.push('init');
					break;
				case 'first-page': // it is initialized
					!remove && templ.status.push('first-page');
					break;
				case 'loading': // any page is loading
					removeStatus(displayStates, helperLoadingStates);
					!remove && templ.status.push('loading');
					break;
				case 'loaded': // any page has loaded
					removeStatus(displayStates);
					!remove && templ.status.push('loaded');
					break;
				case 'complete': // All pages loaded
					removeStatus(displayStates);
					templ.status.push('complete')
					templ.status.push('loaded')
					break;
				case 'no-results':
					removeStatus(displayStates);
					templ.status.push('no-results')
					templ.status.push('loaded')
					break;
				case 'error': // Error occurred during fetch
					removeStatus(displayStates);
					templ.status.push('error')
					templ.status.push('loaded')
					break;
				case 'has-filter': // If filter is set
					!remove && templ.status.push('has-filter')
					break;
				case 'resetting': // loading removing filters.
					!remove && templ.status.push('resetting')
					break;
				case 'filtering': // loading with filter
					!remove && templ.status.push('filtering')
					break;
				case 'triggering-filter': // From no filter to filter.
					!remove && templ.status.push('triggering-filter')
					break;
				default:
					console.warn(`Unknown status: ${status}`);
					break;
			}
		}

		const setStatusString = (el) => {
			el.setAttribute(`${this.attr}-status`, templ.status.join(','))
		}

		templ.status = [...new Set(templ.status)];

		// filters holder status
		templ.wrapper() && setStatusString(templ.wrapper());

		// controllers
		let controllers = document.querySelectorAll(`[${this.attr}-trigger*="${templ.id}"],[data-${this.attr}-trigger*="${templ.id}"]`);
		controllers && controllers.forEach(el => setStatusString(el))

		// indicators
		let indicators = templ.indicators && document.querySelectorAll(`${templ.indicators}`);
		indicators && indicators.forEach(el => setStatusString(el));

		// filters holders
		let filters = Object.keys(this.filters).filter(k => k === templ.id);
		filters.length && filters.map(k => {
			let filters = document.querySelectorAll(this.filters[k].handler.formSelector);
			filters && filters.forEach(el => setStatusString(el))
		});

	}

	async fireEvent(eventName, eventDetail, cancelable = true) {

		if (!this.events.hasOwnProperty(eventName)) return eventDetail;

		eventName = this.events[eventName];

		const promises = [];
		const event = new CustomEvent(eventName, {
			cancelable,
			detail: {
				...eventDetail,
				respondWith: (promise) => { // use this in case of need to await something.
					promises.push(Promise.resolve(promise));
				}
			}
		});

		const cancelled = !window.dispatchEvent(event);

		await Promise.all(promises);

		if (cancelled || event.detail.cancelled ) {
			console.warn(`${eventName} was cancelled`);
			return { ...eventDetail, ...event.detail, cancelled: true };
		}

		return { ...eventDetail, ...event.detail };
	}

	createFilter(payloadId, formSelector, urlHandler = false) {
		this.filters[payloadId] = {
			handler: new ModelsFilter(formSelector, payloadId),
			id: this.generateUniqueId(),
			status: 'idle',
			steps: [],
			urlHandler: urlHandler,
		}
	}

	setFilterStep(payloadId, event, callable, delay = 0, mode = 'replace') {
		if (!this.filters[payloadId]) {
			console.warn(`Filter with payloadId ${payloadId} does not exist.`);
			return;
		}
		this.filters[payloadId].steps.push({ event, callable, delay, mode });
		this.filters[payloadId].handler.setFilter(event, callable);
	}

	filterListeners() {
		const debounceTimers = {};

		const debounce = (callback, delay, filter) => {
			return (...args) => {
				clearTimeout(debounceTimers[filter]);
				debounceTimers[filter] = setTimeout(() => callback(...args), delay);
			};
		};

		const processFilter = async (e, filter) => {
			const args = this.models.payloads[filter].body.args;
			for (const step of this.filters[filter].steps) {
				if (step.event === e.type) {
					const process = await this.filters[filter].handler.process(e, args);
					if (process && process.update) {
						const eventDetail = {
							templ: this.templates.find(templ => templ.id === filter),
							filterArgs: process.args,
							payload: this.models.payloads[filter],
							mode: step.mode
						};
						const event = await this.fireEvent('beforeFilter', eventDetail);
						await this.updater(filter, event.filterArgs, event.mode);
						this.fireEvent('afterFilter', eventDetail, false);
					}
				}
			}
		};

		const filterProcessor = (e) => {
			if (!Object.keys(this.filters).length) return;
			Object.keys(this.filters).forEach(filter => {
				const steps = this.filters[filter].steps.filter(step => step.event === e.type);
				steps.forEach(step => {
					debounce(() => processFilter.bind(this)(e, filter), step.delay, filter)();
				});
			});
		};

		window.addEventListener('change', filterProcessor.bind(this), false);
		window.addEventListener('submit', filterProcessor.bind(this), false);
		window.addEventListener('input', filterProcessor.bind(this), false);
	}

	async URLSetter(templId) {
		const filter = this.filters[templId];
		const payloadArgs = this.models.payloads[templId]?.body.args;
		const urlHandler = filter?.urlHandler;
		const setter = urlHandler?.setter;
		const newURL = setter && payloadArgs && setter(payloadArgs);
		newURL && window.history.replaceState({}, '', newURL);
	}

	async parseFilterQueryString(templId) {
		const filter = this.filters[templId];
		const urlHandler = filter?.urlHandler;
		const getter = urlHandler?.getter;

		if (!getter) return;

		const payload = this.models.payloads[templId];
		const urlParams = await this.queryStringToObject();
		const interfaceHandler = urlHandler?.interface;
		const form = document.querySelector(filter.handler.formSelector);

		if (!payload) return;

		const updatedArgs = getter(urlParams, payload.body.args);
		await this.models.updatePayloadArgs(templId, updatedArgs);

		if (!form || !interfaceHandler) return;

		await interfaceHandler(form, urlParams, this.models.payloads[templId]);

	}

	async queryStringToObject() {
		const urlSearchParams = new URLSearchParams(window.location.search);
		if (!urlSearchParams.size) {
			return false;
		}
		const urlParams = {};

		urlSearchParams.forEach((value, key) => {
			const match = key.match(/^(.+)\[(\d+)]$/); // Regex to match keys like "category[0]"
			if (match) {
				const paramKey = match[1];
				const index = parseInt(match[2]);
				if (!urlParams[paramKey]) {
					urlParams[paramKey] = [];
				}
				urlParams[paramKey][index] = value;
			} else {
				urlParams[key] = value; // Handle non-array keys normally
			}
		});
		return urlParams;
	}

	parseTrigger(input) {
		return input.split('|').reduce((result, event) => {
			const [actionPart, testPart] = event.split('=');
			const actionName = actionPart.match(/\[([^\]]+)\]/)[1];
			const testName = actionPart.replace(/\[([^\]]+)\]/, '').trim();
			const parameters = testPart.replace(/[{}]/g, '').split(',');

			if (!result[actionName]) result[actionName] = {};

			const paramObj = parameters.reduce((params, param) => {
				const [key, value] = param.split(':').map(str => str.trim());
				params[key] = value.startsWith('(') && value.endsWith(')')
					? () => document.querySelector(value.slice(1, -1))
					: value;
				return params;
			}, {});

			result[actionName][testName] = paramObj;
			return result;
		}, {});
	}

	generateUniqueId() {
		return Math.random().toString(16).slice(2);
	}

	isScrolledIntoView(el) {
		const rect = el.getBoundingClientRect();
		return rect.top < window.innerHeight && rect.bottom >= 0;
	}

	throttle(func, limit) {
		let lastFunc;
		let lastRan;

		return function () {
			const context = this;
			const args = arguments;

			if (!lastRan) {
				func.apply(context, args)
				lastRan = Date.now();
			} else {
				clearTimeout(lastFunc);
				lastFunc = setTimeout(() => {
					if ((Date.now() - lastRan) >= limit) {
						func.apply(context, args);
						lastRan = Date.now();
					}
				}, limit - (Date.now() - lastRan));
			}
		}
	}

	error(message, object = false) {
		if (object) console.error(object);
		throw new Error(message);
	}
}
